import {ActionList} from '@primer/react'

import {CommentsPreference} from '../types'
import {useUpdateUserDiffViewPreferenceMutation} from '../hooks/mutations/use-update-user-diff-view-preference-mutation'
import {useUserDiffViewSettingsData} from '../page-data/payloads/diff-view-settings'

export function DiffCommentsPreferenceToggle() {
  const {data} = useUserDiffViewSettingsData()
  const {mutate: updateUserDiffViewPreference} = useUpdateUserDiffViewPreferenceMutation({
    onSuccess: () => {},
    onError: () => {},
  })

  if (!data) return null

  const isCollapsed = data.commentsPreference === CommentsPreference.Collapsed

  return (
    <ActionList.Group aria-label="Comments" selectionVariant="single">
      <ActionList.Item
        role="menuitemcheckbox"
        selected={isCollapsed}
        onSelect={() =>
          updateUserDiffViewPreference({
            commentsPreference: isCollapsed ? CommentsPreference.Visible : CommentsPreference.Collapsed,
          })
        }
      >
        Minimize comments
      </ActionList.Item>
    </ActionList.Group>
  )
}

try{ DiffCommentsPreferenceToggle.displayName ||= 'DiffCommentsPreferenceToggle' } catch {}